import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function capitalizeFirstLetter(val: string) {
  return String(val).charAt(0).toUpperCase() + String(val).slice(1);
}

export function getSeasonalEmoji() {
  const today = new Date();
  const month = today.getMonth();

  if (month === 11 || month === 0 || month === 1) {
    return {
      seasonPrimary: "❄️",
      seasonSecondary: "⛄️",
    };
  } else if (month === 2 || month === 3) {
    return {
      seasonPrimary: "🌸",
      seasonSecondary: "🐣",
    };
  } else if (month >= 4 && month <= 7) {
    return {
      seasonPrimary: "🌞",
      seasonSecondary: "🏖️",
    };
  } else {
    return {
      seasonPrimary: "🍂",
      seasonSecondary: "🎃",
    };
  }
}

export function formatTimestampToNaturalLanguage(timestamp: string): string {
  const pastDate = new Date(timestamp);
  const now = new Date();

  // Calculate the difference in milliseconds
  const diffMs = now.getTime() - pastDate.getTime();

  // Convert to various units
  const diffSeconds = Math.floor(diffMs / 1000);
  const diffMinutes = Math.floor(diffSeconds / 60);
  const diffHours = Math.floor(diffMinutes / 60);
  const diffDays = Math.floor(diffHours / 24);
  const diffWeeks = Math.floor(diffDays / 7);
  const diffMonths = Math.floor(diffDays / 30);
  const diffYears = Math.floor(diffDays / 365);

  // Return appropriate format
  if (diffSeconds < 60) {
    return diffSeconds === 1 ? "1 second ago" : `${diffSeconds} seconds ago`;
  } else if (diffMinutes < 60) {
    return diffMinutes === 1 ? "1 minute ago" : `${diffMinutes} minutes ago`;
  } else if (diffHours < 24) {
    return diffHours === 1 ? "1 hour ago" : `${diffHours} hours ago`;
  } else if (diffDays < 7) {
    return diffDays === 1 ? "1 day ago" : `${diffDays} days ago`;
  } else if (diffWeeks < 4) {
    return diffWeeks === 1 ? "1 week ago" : `${diffWeeks} weeks ago`;
  } else if (diffMonths < 12) {
    return diffMonths === 1 ? "1 month ago" : `${diffMonths} months ago`;
  } else {
    return diffYears === 1 ? "1 year ago" : `${diffYears} years ago`;
  }
}

export function removeUnderscoreAndSpaceText(value: string): string {
  return value
    .split("_")
    .map(
      word => word.charAt(0).toUpperCase() + word.slice(1)
    )
    .join(" ");
}

// lib/jobColors.ts
export function getJobPostCategoryColor(category: string): string {
  switch (category) {
    case "software_development":
      return "#3B82F6"; // Bright Blue

    case "customer_success":
      return "#34D399"; // Mint Green

    case "design":
      return "#FBBF24"; // Amber / Yellow

    default:
      return "#9CA3AF"; // Neutral gray fallback
  }
}


